import React, { useLayoutEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import './WeddingDay.css';
import { useBootstrapWeddingDay } from './state/useWeddingDay';
import { WeddingDayStore } from './state/store';
import { isAdminBuild } from './runtime';
import Shell from './Shell';

/**
 * The couple's own wedding day form, or a staff read of it.
 *
 * `chrome` is whatever the host app puts above the page (its navbar) and
 * `useStoreToken` is its token bootstrap, because both differ between the
 * customer app and the professional app. `readOnly` forces the staff read:
 * the professional app has no write access at all.
 */
const WeddingDayPage = ({
  chrome, useStoreToken, navSelector, staff, readOnly: forcedReadOnly,
  onSubmitted,
}) => {
  const { booking_id: bookingId } = useParams();
  const [params] = useSearchParams();
  // The brief uuid comes off the deep link ops generates in the egadmin Planner.
  const briefUuid = params.get('brief') || '';
  const readOnly = forcedReadOnly
    // egadmin's staff view links here with ?readonly=true.
    || params.get('readonly') === 'true'
    // Login as User: the admin build (REACT_APP_IS_ADMIN=true) uses the
    // couple's own token, so only the build tells us ops is the one reading.
    || isAdminBuild();
  // Whose side that read is made as. The token leaves the address bar on load,
  // this does not: without it the server has no participant to read for.
  const asRole = params.get('as_role') || null;
  const { storeToLocal } = useStoreToken();

  // Must run before the bootstrap effect: it moves ?token= into localStorage
  // and strips it from the address bar, so the token is not left copyable.
  useLayoutEffect(() => {
    storeToLocal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useBootstrapWeddingDay({ bookingId, briefUuid, readOnly, asRole });

  return React.createElement(
    React.Fragment,
    null,
    chrome,
    React.createElement(Shell, {
      navSelector,
      staff,
      // Where the couple goes once the form is in is the host's call: only
      // the customer app has somewhere to send them.
      onSubmitted,
    })
  );
};

const WeddingDay = (props) =>
  React.createElement(
    WeddingDayStore,
    null,
    React.createElement(WeddingDayPage, { ...props })
  );

export default WeddingDay;
